/**
 * Return date in YYYY-MM-DD format
 * @param {Object} date 
 * @returns {String} date in YYYY-MM-DD format
 */
export function formatDate(date) {
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // getMonth() returns a zero-based index
  let day = date.getDate();

  // Add leading zero to month and day if necessary
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;

  return year + '-' + month + '-' + day;
}

/**
 * Pushes a date forward by a specified number of days
 * @param {Object} date
 * @param {Number} days
 * @returns {Object} new date object
 */
export function pushDate(date, days) {
  let newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

/**
 * Converts a clinic DOB to yyyy-mm-dd format
 * @param {String} dateString in MM/DD/YYYY format
 * @returns 
 */
export function convertDatetoYMD(dateString) {
  // Split the date by '/'
  var parts = dateString.split('/');

  // Reorder the date parts and join with '-'
  return parts[2] + '-' + parts[0] + '-' + parts[1];
}